(() => {
  function sanitize(val) {
    const n = Math.floor(Number(val || 0));
    return Number.isFinite(n) && n > 0 ? n : 0;
  }

  function findWrapperForForm(form) {
    const section = form.closest("section");
    if (section) {
      const w = section.querySelector("[data-multi-variant-qty]");
      if (w) return w;
    }
    return document.querySelector("[data-multi-variant-qty]");
  }

  function getInputs(wrapper) {
    return Array.from(wrapper.querySelectorAll("input[data-variant-id]"));
  }

  function setError(wrapper, msg) {
    const el = wrapper.querySelector(".variant-qty-error");
    if (!el) return;
    if (!msg) {
      el.hidden = true;
      el.textContent = "";
    } else {
      el.hidden = false;
      el.textContent = msg;
    }
  }

  function updateTotal(wrapper) {
    const inputs = getInputs(wrapper);
    const total = inputs.reduce((sum, i) => sum + sanitize(i.value), 0);
    const totalEl = wrapper.querySelector("[data-total-selected]");
    if (totalEl) totalEl.textContent = String(total);
    return total;
  }

  // Keep totals updated (delegated)
  document.addEventListener("input", (e) => {
    const input = e.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (!input.matches("input[data-variant-id]")) return;

    input.value = String(Math.max(0, Math.floor(Number(input.value || 0))));

    const wrapper = input.closest("[data-multi-variant-qty]");
    if (!wrapper) return;

    const minTotal = Number(wrapper.dataset.minTotal || 0);
    const t = updateTotal(wrapper);
    if (minTotal > 0 && t >= minTotal) setError(wrapper, "");
  });

  document.addEventListener("change", (e) => {
    const input = e.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (!input.matches("input[data-variant-id]")) return;

    const wrapper = input.closest("[data-multi-variant-qty]");
    if (!wrapper) return;

    updateTotal(wrapper);
  });

  // Intercept submit BEFORE Dawn handles it (capture phase)
  document.addEventListener(
    "submit",
    async (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.closest("product-form")) return;

      const wrapper = findWrapperForForm(form);
      if (!wrapper) return; // not a MIN:: product / no multi-variant UI

      // Stop Dawn's normal submission
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation?.();

      const minTotal = Number(wrapper.dataset.minTotal || 0);
      const inputs = getInputs(wrapper);

      // Build updates map for ALL variants shown (including 0)
      const updates = {};
      let total = 0;

      inputs.forEach((i) => {
        const id = Number(i.dataset.variantId);
        const qty = sanitize(i.value);
        if (Number.isFinite(id)) updates[id] = qty;
        total += qty;
      });

      updateTotal(wrapper);

      if (minTotal > 0 && total < minTotal) {
        setError(wrapper, `Minimum purchase of ${minTotal} is required.`);
        return;
      }

      // Optional: if they set everything to 0, block it (otherwise it just clears)
      if (total === 0) {
        setError(wrapper, "Please select at least 1 item.");
        return;
      }

      setError(wrapper, "");

      const submitBtn = form.querySelector('[type="submit"]');
      submitBtn?.setAttribute("aria-disabled", "true");

      try {
        const root = window.Shopify?.routes?.root || "/";
        const res = await fetch(`${root}cart/update.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ updates }),
        });

        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err?.description || err?.message || "Could not update cart.");
        }

        // Simple reliable behavior
        window.location.href = `${root}cart`;
      } catch (err) {
        setError(wrapper, err?.message || "Something went wrong updating the cart.");
      } finally {
        submitBtn?.removeAttribute("aria-disabled");
      }
    },
    true
  );

  // Init totals on load (supports prefilled values from cart)
  document.querySelectorAll("[data-multi-variant-qty]").forEach((w) => updateTotal(w));
})();

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-remove-all]');
  if (!btn) return;

  const container = document.querySelector('[data-multi-variant-qty]');
  if (!container) return;

  btn.disabled = true;
  btn.textContent = 'Removing…';

  const inputs = container.querySelectorAll('[data-variant-id]');
  const updates = {};

  inputs.forEach(input => {
    updates[input.dataset.variantId] = 0;
    input.value = 0;
  });

  await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates })
  });

  window.location.href = '/cart';
});

document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('[data-multi-variant-qty]');
  if (!container) return;

  const min = parseInt(container.dataset.minTotal || 0, 10);
  const inputs = container.querySelectorAll('[data-variant-id]');
  const totalEl = container.querySelector('[data-total-selected]');
  const errorEl = container.querySelector('.multi-variant-quantities__error');
  const submitBtn = document.querySelector('[name="add"]');

  function update() {
    let total = 0;

    inputs.forEach(input => {
      total += parseInt(input.value || 0, 10);
    });

    if (totalEl) totalEl.textContent = total;

    const underMin = total < min;

    // ✅ always disable when under min
    submitBtn.disabled = underMin;

    // ✅ only show message when min > 1
    if (errorEl) {
      if (min > 1 && underMin) {
        errorEl.hidden = false;
        errorEl.textContent = `Minimum ${min} total required`;
      } else {
        errorEl.hidden = true;
      }
    }
  }

  inputs.forEach(input => {
    input.addEventListener('input', update);
  });

  update();
});